import React from 'react';
import { Helmet } from 'react-helmet-async';
import Team from '../components/Team/Team';
import Stats from '../components/Stats/Stats';
import ContactForm from '../components/ContactForm/ContactForm';
import styles from './About.module.css';

export default function About() {
  return (
    <>
      <Helmet>
        <title>О компании — ООО Советник | Юридическое сопровождение ВЭД</title>
        <meta name="description" content="ООО Советник — команда профессионалов в сфере внешнеэкономической деятельности. Более 20 лет опыта, 500+ успешных проектов. Узнайте больше о нашей компании." />
        <link rel="canonical" href="https://konsultant-sovetnik.ru/about" />
        <meta property="og:title" content="О компании — ООО Советник" />
        <meta property="og:description" content="Команда профессионалов в сфере ВЭД. Более 20 лет опыта." />
        <meta property="og:url" content="https://konsultant-sovetnik.ru/about" />
        <meta property="og:image" content="https://konsultant-sovetnik.ru/logo512.png" />
        <meta property="og:type" content="website" />
        <script type="application/ld+json">{JSON.stringify({
          "@context": "https://schema.org",
          "@type": "AboutPage",
          "name": "О компании — ООО Советник",
          "url": "https://konsultant-sovetnik.ru/about",
          "about": {
            "@type": "Organization",
            "name": "ООО Советник",
            "foundingDate": "2006",
            "url": "https://konsultant-sovetnik.ru/"
          }
        })}</script>
      </Helmet>
      <section className={styles.hero}>
        <div className={styles.container}>
          <span className={styles.badge}>О компании</span>
          <h1 className={styles.title}>ООО «Советник»</h1>
          <p className={styles.subtitle}>Ваш юридический советник по ВЭД</p>
        </div>
      </section>

      <section className={styles.section}>
        <div className={styles.container}>
          <div className={styles.content}>
            <div className={styles.textBlock}>
              <h2>Кто мы</h2>
              <p>
                Мы — команда профессионалов в сфере внешнеэкономической деятельности,
                которая помогает российским компаниям успешно импортировать товары из-за рубежа
                и выходить на международные рынки.
              </p>
              <p>
                Наша компания предоставляет высокий уровень юридического и логистического
                сопровождения при осуществлении импорта товаров из Европы, Турции, Китая и Индии,
                а также комплексное сопровождение экспортных операций из РФ.
              </p>
            </div>
            <div className={styles.textBlock}>
              <h2>Наша миссия</h2>
              <p>
                Сделать международную торговлю доступной и понятной для каждого предпринимателя.
                Мы берём на себя все сложности, связанные с законодательством, логистикой и
                документацией, чтобы вы могли сосредоточиться на развитии своего бизнеса.
              </p>
            </div>
          </div>

          <div className={styles.geography}>
            <h2 className={styles.geoTitle}>География работы</h2>
            <div className={styles.geoGrid}>
              {[
                { flag: '🇪🇺', name: 'Европа', desc: 'Германия, Италия, Франция и другие страны ЕС' },
                { flag: '🇹🇷', name: 'Турция', desc: 'Один из ключевых торговых партнёров' },
                { flag: '🇨🇳', name: 'Китай', desc: 'Крупнейший поставщик широкого спектра товаров' },
                { flag: '🇮🇳', name: 'Индия', desc: 'Растущий рынок с огромным потенциалом' },
                { flag: '🇻🇳', name: 'Вьетнам', desc: 'Динамично развивающийся партнёр в Юго-Восточной Азии' }
              ].map((country, i) => (
                <div className={styles.geoCard} key={i}>
                  <span className={styles.flag}>{country.flag}</span>
                  <h4>{country.name}</h4>
                  <p>{country.desc}</p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </section>

      <Stats />
      <Team />
      <ContactForm type="consultation" />
    </>
  );
}
